// Notification modal modes
export const NOTIFICATION_MODE = {
  PAUSE: "pause",
  RESUME: "resume",
};

// Notification modal content
export const NOTIFICATION_MODAL_CONTENT = {
  [NOTIFICATION_MODE.PAUSE]: {
    title: "Pause Notifications",
    message: "Are you sure you want to disable chat notifications for this event?",
  },
  [NOTIFICATION_MODE.RESUME]: {
    title: "Resume Notifications",
    message: "Are you sure you want to resume chat notifications for this event?",
  },
};

// LocalStorage keys for notifications
export const NOTIFICATION_STORAGE_KEYS = {
  FCM_TOKEN: "fcmToken",
  FCM_BANNER_DISMISSED: "fcmBannerDismissed",
};

// Permission states
export const PERMISSION_STATE = {
  DEFAULT: "default",
  GRANTED: "granted",
  DENIED: "denied",
};

// FCM Banner UI text
export const FCM_BANNER_TEXT = {
  PERMISSION_MESSAGE: "Eventscribe needs your permission to enable desktop notifications",
  ENABLE_BUTTON: "Enable",
};
